import React from 'react';
import { Cloudinary } from '@cloudinary/url-gen';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CloudinaryPhoto from './cloudinary/CloudinaryPhoto';

const cld = new Cloudinary({
  cloud: {
    cloudName: 'prodz-com',
    uploadPreset: 'profile_photos',
  },
});

const ProfilePhoto = ({ photo, profile_photo, gender }) => {
  // Default avatars based on gender if no Cloudinary profile photo is provided
  let photoUrl = null;
  if (photo) photoUrl = photo;
  else if (gender === 'Man') photoUrl = 'avatar-man-1.png';
  else if (gender === 'Woman') photoUrl = 'avatar-woman-1.png';
  else photoUrl = 'avatar-no-gender-1.png';

  const renderImage = () => {
    if (profile_photo?.key) {
      // Render Cloudinary image when `profile_photo` has a `key`
      return (
        <CloudinaryPhoto
          cloudName={cld.cloudinaryConfig.cloud.cloudName}
          publicId={profile_photo.key}
          alt="avatar"
          className="w-20 h-20 rounded-full object-cover"
        />
      );
    } else {
      // Render default avatar based on gender
      return (
        <LazyLoadImage
          className="w-20 h-20 rounded-full object-cover"
          src={`https://filmconnx-production.s3.amazonaws.com/uploads/${photoUrl}`}
          alt="avatar"
        />
      );
    }
  };

  return (
    <a
      className="dropdown-toggle"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {renderImage()}
    </a>
  );
};

export default ProfilePhoto;
